import { render } from "./Product.vue?vue&type=template&id=5e9ee306&scoped=true"
import script from "./Product.vue?vue&type=script&lang=ts"
export * from "./Product.vue?vue&type=script&lang=ts"

import "./Product.vue?vue&type=style&index=0&id=5e9ee306&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5e9ee306"

export default script